module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_07-b82854eb9eeee446978631ec2c6ecae3.png";